module.exports = __webpack_public_path__ + "dist/assets/img/header_ateliers.f688019f.jpg";